import { type FeatureFlagName } from '#/shared/types/FeatureFlag';

export type LocalhostTreatments = Record<FeatureFlagName, SplitIO.TreatmentWithConfig>;

export const localhostTreatments: LocalhostTreatments = {
  'ABC-000-unit-tests-flag': { treatment: 'on', config: null },
  'PPL-2119-paid-break-exception': { treatment: 'on', config: null },
  'PPL-2300-signature-as-array-of-strings': { treatment: 'on', config: null },
  'PPL-2240-verify-timesheet-action': { treatment: 'on', config: null },
} as const;
